import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'dateTimeZone',
    pure: false
})
export class DateTimeZonePipe implements PipeTransform {
    constructor() {}

    transform(value: any, timeZone: string, format?: string): any {
        if (!value || !timeZone) return value;

        // Parse as UTC and convert to selected time zone
        const utcMoment = moment.tz(value, 'UTC');
        const localizedMoment = utcMoment.tz(timeZone);

        // Convert Angular format to Moment format
        const momentFormat = this.convertAngularFormat(format);
        return localizedMoment.format(momentFormat);
    }

    private convertAngularFormat(angularFormat?: string): string {
        if (!angularFormat) return 'YYYY-MM-DD HH:mm:ss';

        return angularFormat
            .replace(/yyyy/g, 'YYYY')
            .replace(/dd/g, 'DD')
            .replace(/HH/g, 'HH')
            .replace(/mm/g, 'mm')
            .replace(/ss/g, 'ss');
    }
}
